import React from 'react';

import { QueueCodes } from '../../../constants/workflows';
import { TimecardsListPage } from '../../shared/timecards';
import { ORGANIZATION_TIMECARDS_LIST_QUERY_KEY } from './queryKeys';

const QUEUE_CATEGORY = 'HealthcareEntityTimecardQueueNames';

export const TimecardsList: React.FC = () => {
  return (
    <TimecardsListPage
      title="Timecards"
      queryKeyBase={ORGANIZATION_TIMECARDS_LIST_QUERY_KEY}
      displayTypePrefKey="OrganizationTimecards"
      showOrganization={false}
      linkContext="organization"
      queueCategory={QUEUE_CATEGORY}
      priorityQueues={true}
      priorityQueueList={[QueueCodes.NEEDS_RESPONSE]}
    />
  );
};
